import React from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import './LoadingOverlay.scss';

const useStyles = makeStyles(theme => ({
    root: {
      zIndex: 2000,
      color: '#fff'
    }
}));

const LoadingOverlay = (props) => {
    const classes = useStyles();

    return (
        <Backdrop className={classes.root} open={true}>
            <CircularProgress color="inherit" />
        </Backdrop>
    );
};
export default LoadingOverlay;